export default __webpack_public_path__ + "static/media/intro_img5.ac0fdf52.png";